module.exports = __webpack_public_path__ + "img/stamp-diving.48f4da37.png";